import { AtomEffect } from "recoil";
import { recoilPersist } from "recoil-persist";

export default function implementPersist(key: any) {
  const { persistAtom } = recoilPersist({
    key,
    storage: localStorage,
  });

  return [persistAtom];
}

export function implementSessionPersist(key: any) {
  const { persistAtom } = recoilPersist({
    key,
    storage: sessionStorage,
  });

  return [persistAtom];
}

export function deleteFromLocalStorage(key: string): void {
  localStorage.removeItem(key);
}

export function getAndDeleteFromLocalStorage<T>(key: string): T | null {
  const raw = localStorage.getItem(key);
  if (raw === null) return null;
  localStorage.removeItem(key);
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function implementGetAndDeleteFromLocalStorage<T>(key: string): AtomEffect<T>[] {
  const effect: AtomEffect<T> = ({ setSelf, onSet }) => {
    const raw = localStorage.getItem(key);
    if (raw !== null) {
      localStorage.removeItem(key);
      try {
        setSelf(JSON.parse(raw) as T);
      } catch {
        // ignore malformed data
      }
    }

    onSet((newValue, _, isReset) => {
      if (isReset || newValue === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };

  return [effect];
}
